import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

export default [
  {
    component: LazyComponent(lazy(() => import('./CreateMultipleTasks'))),
    path: '/task/create-multiple',
  },
];
